<div class="p-2">
  <!-- Header Section -->
  <div class="flex flex-wrap justify-between gap-2 items-center mb-6">
    <div>
      <h1 class="text-2xl font-bold text-gray-800">Subscriber Management</h1>
      <p class="text-gray-600">Manage subscribers across the system.</p>
    </div>
    <div class="flex gap-3">
      <!-- <p-button 
          label="Export" 
          icon="pi pi-download" 
          severity="secondary"
          (onClick)="exportUsers()"
          [disabled]="loading">
        </p-button> -->
      <p-button label="Invite New Subscriber"
        icon="pi pi-plus"
        (onClick)="addNewUser()" [disabled]="loading">
      </p-button>
    </div>
  </div>

  <!-- Search and Filters -->
  <p-card styleClass="mb-6">
    <div class="flex flex-col lg:flex-row gap-4">
      <!-- Search Input -->
      <div class="flex-1">
        <span class="">
          <p-iconfield iconPosition="left">
            <p-inputicon>
              <i class="pi pi-search"></i>
            </p-inputicon>
            <input pInputText type="text" placeholder="Search subscribers by company name, email..." i18n-placeholder
              [(ngModel)]="searchText" (keyup.enter)="applyFilters()" class="min-w-[200px]" fluid>
          </p-iconfield>

        </span>
      </div>

      <!-- Filters -->
      <div class="flex flex-wrap gap-3">

  <p-select [options]="userStatusOptions" [(ngModel)]="selectedUserStatus" placeholder="User Status: All" i18n-placeholder
          optionLabel="label" optionValue="value" styleClass="min-w-[150px]">
        </p-select>



      </div>

      <!-- Action Buttons -->
      <div class="flex gap-2">
        <p-button label="Search" icon="pi pi-search" (onClick)="applyFilters()" [disabled]="loading">
        </p-button>
        <p-button label="Reset" icon="pi pi-refresh" severity="secondary" [outlined]="true" (onClick)="resetFilters()"
          [disabled]="loading">
        </p-button>
      </div>
    </div>
  </p-card>

  <!-- Users Table -->
  <p-card class="!p-3">
    <div class="overflow-x-auto min-h-screen">
      <p-table [value]="subscribers" [loading]="loading" [paginator]="false" [rows]="pageSize"
        [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [tableStyle]="{'min-width': '1000px', 'width': '100%'}" styleClass="p-datatable-sm">

        <!-- User Column -->
        <ng-template pTemplate="header">
          <tr>
            <th class="min-w-[200px]">COMPANY</th>
            <th class="min-w-[120px]">SUPER ADMIN</th>
            <th class="min-w-[140px]">ACTIVE USERS</th>
            <th class="min-w-[100px]">USER STATUS</th>
            <th class="min-w-[120px] cursor-pointer hover:bg-gray-50 transition-colors duration-200"
              (click)="toggleSort()">
              <div class="flex items-center justify-between">
                <span>CREATED</span>
                <i class="pi" [ngClass]="sortOrder === -1 ? 'pi-sort-down' : 'pi-sort-up'"></i>
              </div>
            </th>
            <th class="min-w-[180px]">ACTIONS</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-subscriber>
          <tr [ngClass]="{'!bg-yellow-50': subscriber.status === 'PENDING'}">
            <!-- Company Info -->
            <td class="min-w-[200px]">
              <div class="flex items-center gap-3">
                <img [src]="subscriber.companyLogo || 'https://i0.wp.com/sectour.co/wp-content/uploads/2015/04/logo-placeholder.jpg?ssl=1'" i18n-alt class="w-10 h-10 object-contain rounded-lg border border-gray-200 p-1">
                
                <div>
                  <div class="font-semibold">{{ subscriber.companyName.split(' ').length > 2 ?
                    subscriber.companyName.split(' ').slice(0, 2).join(' ') + '...' : subscriber.companyName }}</div>
                  @if (subscriber.refNo) {
                  <div class="text-xs text-gray-400 mt-1">{{ subscriber.refNo }}</div>
                  }
                </div>
              </div>
            </td>

            <!-- Super Admin Info-->
            <td class="min-w-[200px]">
              <div class="flex items-center gap-3">
                <p-avatar [label]="getInitials(subscriber.firstName, subscriber.lastName)" size="normal"
                  [style]="{'background-color': '#0061DD', 'color': '#FFFFFF'}" shape="circle">
                </p-avatar>
                <div>
                  <div class="font-semibold">{{ subscriber.firstName }} {{ subscriber.lastName }}</div>
                  <div class="text-sm text-gray-500">
                    <a href="mailto:{{ subscriber.email }}"
                      class="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200">{{
                      subscriber.email }}</a>
                  </div>
                </div>
              </div>
            </td>

            <!-- No of active users-->
            <td class="min-w-[140px]">
              <span class="text-gray-600 flex justify-center">{{ getActiveUsers(subscriber._id) }}</span>
            </td>


            <!-- User Status -->
            <td class="min-w-[100px]">
              <p-tag [value]="subscriber.user?.isActive ? 'Active' : 'Inactive'"
                [severity]="subscriber.user?.isActive ? 'success' : 'danger'">
              </p-tag>
            </td>


            <!-- Created Date -->
            <td class="min-w-[120px]">
              <span class="text-gray-600">{{ formatDate(subscriber.createdAt) }}</span>
            </td>

            <!-- Actions -->
            <td class="min-w-[180px]">
              <div class="flex items-center gap-2">

                <div>
                  <p-button appGlobalLoadingDisable label="View User" size="small" [outlined]="true"
                    (onClick)="openSubscriberReview(subscriber._id)">
                  </p-button>
                </div>


                <!-- <div class="relative">
                    <p-button appGlobalLoadingDisable 
                      icon="pi pi-ellipsis-v" 
                      size="small"
                      severity="secondary"
                      [text]="true"
                      (onClick)="showActionMenu($event, subscriber)"
                      pTooltip="Actions">
                    </p-button>
                  </div> -->

              </div>
            </td>
          </tr>
        </ng-template>

        <!-- Empty State -->
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center py-8">
              <div class="flex flex-col items-center gap-2">
                <i class="pi pi-users text-4xl text-gray-300"></i>
                <p class="text-gray-500">No users found</p>

              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- Pagination -->
      <div class="flex flex-wrap justify-between gap-2  mt-4">
        <div class="text-sm text-gray-600">
          Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ Math.min(currentPage * pageSize, totalSubscribers) }} of
          {{ totalSubscribers }} entries
        </div>

        <p-paginator [rows]="pageSize" [totalRecords]="totalSubscribers" [rowsPerPageOptions]="pageSizes"
          (onPageChange)="onPageChange($event)" [showCurrentPageReport]="false">
        </p-paginator>
      </div>
    </div>
  </p-card>

  <!-- Action Menu (outside table for better positioning) -->
  <p-menu #menu [popup]="true" [model]="actionMenuItems" appendTo="body">
  </p-menu>

  <!-- Subscriber Review Drawer -->
  <p-drawer [(visible)]="isDrawerVisible" position="right" [modal]="true"
    styleClass="!w-full md:!w-[30rem] lg:!w-[60rem]">

    <ng-template pTemplate="headless">
      <div class="flex flex-col h-full">
        <!-- Header -->
        <div class="flex items-center justify-between px-6 py-2 shrink-0 border-b border-gray-200">
          <h2 class="">Subscriber Review</h2>
          <p-button appGlobalLoadingDisable icon="pi pi-times" [text]="true" [rounded]="true" (onClick)="closeUserReview()">
          </p-button>
        </div>

        <!-- Content -->
        <div class="flex-1 overflow-y-auto p-6">
          <!-- Loading State -->
          @if (subscriberReviewLoading) {
          <div class="flex flex-col items-center justify-center py-8">
            <i class="pi pi-spin pi-spinner text-4xl text-blue-500 mb-4"></i>
            <p class="text-gray-600">Loading subscriber details...</p>
          </div>
          }

          <!-- Subscriber Details -->
          @if (!subscriberReviewLoading && selectedSubscriberForReview) {
          <div class="space-y-6">
            <!-- Company Information -->
            <div class="space-y-4">
              <h3 class="text-lg font-semibold text-gray-800 border-b border-gray-200 pb-2">Company Information</h3>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Company Name</label>
                  <p class="text-gray-900">{{ selectedSubscriberForReview.companyName }}</p>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Company Logo</label>
                  @if (selectedSubscriberForReview.companyLogo) {
                    <img  [src]="selectedSubscriberForReview.companyLogo" alt="Company Logo" i18n-alt
                    class="w-16 h-16 object-contain rounded-lg border border-gray-200 p-1">

                  } @else {
                  <p class="text-gray-500 italic">No logo uploaded</p>
                  }
                </div>

                <!-- <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Status</label>
                  <p-tag [value]="getStatusLabel(selectedSubscriberForReview.status)"
                    [severity]="getStatusBadgeSeverity(selectedSubscriberForReview.status)" class="mt-1">
                  </p-tag>
                </div> -->
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Status</label>
                  <p-tag [value]="selectedSubscriberForReview.user?.isActive ? 'Active' : 'Inactive'"
                    [severity]="selectedSubscriberForReview.user?.isActive ? 'success' : 'danger'" class="mt-1">
                  </p-tag>
                </div>

                <!-- <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">User Status</label>
                    <p-badge 
                      [value]="selectedSubscriberForReview.user?.isActive ? 'Active' : 'Inactive'" 
                      [severity]="selectedSubscriberForReview.user?.isActive ? 'success' : 'danger'"
                      class="mt-1">
                    </p-badge>
                  </div> -->
              </div>
            </div>

            <!-- Contact Information -->
            <div class="space-y-4">
              <h3 class="text-lg font-semibold text-gray-800 border-b border-gray-200 pb-2">Contact Information</h3>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">First Name</label>
                  <p class="text-gray-900">{{ selectedSubscriberForReview.firstName }}</p>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
                  <p class="text-gray-900">{{ selectedSubscriberForReview.lastName }}</p>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Email</label>
                  <p class="text-gray-900">
                    <a href="mailto:{{ selectedSubscriberForReview.email }}"
                      class="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200">{{
                      selectedSubscriberForReview.email }}</a>
                  </p>
                </div>
              </div>
            </div>

            <!-- Business Details -->
            <div class="space-y-4">
              <h3 class="text-lg font-semibold text-gray-800 border-b border-gray-200 pb-2">Business Details</h3>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Industries</label>
                  @if (selectedSubscriberForReview.industries && selectedSubscriberForReview.industries.length > 0) {
                  <div class="flex flex-wrap gap-2 mt-1">
                    @for (industry of selectedSubscriberForReview.industries; track industry) {
                    <span class="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">{{ industry }}</span>
                    }
                  </div>
                  } @else {
                  <p class="text-gray-500 italic">No industries specified</p>
                  }
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Operational Regions</label>
                  @if (selectedSubscriberForReview.operationalRegions &&
                  selectedSubscriberForReview.operationalRegions.length > 0) {
                  <div class="flex flex-wrap gap-2 mt-1">
                    @for (region of selectedSubscriberForReview.operationalRegions; track region) {
                    <span class="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full">{{ region }}</span>
                    }
                  </div>
                  } @else {
                  <p class="text-gray-500 italic">No regions specified</p>
                  }
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Reservation Duration</label>
                  <p class="text-gray-900">{{ selectedSubscriberForReview.contactDuration +" "+'Months' || 'N/A' }}</p>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Preferred Language</label>
                  <p class="text-gray-900">{{ getLanguageName(selectedSubscriberForReview.language) }}</p>
                </div>
              </div>
            </div>

            <!-- Legal Documents -->
            <div class="space-y-4">
              <h3 class="text-lg font-semibold text-gray-800 border-b border-gray-200 pb-2">Legal Documents</h3>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Terms & Conditions</label>
                  @if (selectedSubscriberForReview.termsConditions) {
                  <div class="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                    <div class="flex items-center gap-3">
                      <i class="pi pi-file-text text-blue-500 text-xl"></i>
                      <a [href]="selectedSubscriberForReview.termsConditions" target="_blank" rel="noopener noreferrer"
                        class="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200 cursor-pointer">
                        Terms & Conditions uploaded
                      </a>
                    </div>
                    <div class="flex items-center gap-2">
                      <p-button appGlobalLoadingDisable icon="pi pi-external-link" [text]="true" [rounded]="true"
                        (onClick)="openInNewTab(selectedSubscriberForReview.termsConditions)"
                        pTooltip="Open in New Tab">
                      </p-button>
                    </div>
                  </div>
                  } @else {
                  <p class="text-gray-500 italic">No terms & conditions uploaded</p>
                  }
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Privacy Policy</label>
                  @if (selectedSubscriberForReview.privacyPolicy) {
                  <div class="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                    <div class="flex items-center gap-3">
                      <i class="pi pi-file-text text-green-500 text-xl"></i>
                      <a [href]="selectedSubscriberForReview.privacyPolicy" target="_blank" rel="noopener noreferrer"
                        class="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200 cursor-pointer">
                        Privacy Policy uploaded
                      </a>
                    </div>
                    <div class="flex items-center gap-2">
                      <p-button appGlobalLoadingDisable icon="pi pi-external-link" [text]="true" [rounded]="true"
                        (onClick)="openInNewTab(selectedSubscriberForReview.privacyPolicy)" pTooltip="Open in New Tab">
                      </p-button>
                    </div>
                  </div>
                  } @else {
                  <p class="text-gray-500 italic">No privacy policy uploaded</p>
                  }
                </div>
              </div>
            </div>

            <!-- Additional Information -->
            <div class="space-y-4">
              <h3 class="text-lg font-semibold text-gray-800 border-b border-gray-200 pb-2">Additional Information</h3>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Created Date</label>
                  <p class="text-gray-900">{{ selectedSubscriberForReview.createdAt ?
                    formatDate(selectedSubscriberForReview.createdAt) : 'N/A' }}</p>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Last Updated</label>
                  <p class="text-gray-900">{{ selectedSubscriberForReview.updatedAt ?
                    formatDate(selectedSubscriberForReview.updatedAt) : 'N/A' }}</p>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </ng-template>
  </p-drawer>

  <!-- Confirmation Dialogs -->
  <p-confirmDialog></p-confirmDialog>

  <!-- Toast Messages -->
  <p-toast></p-toast>